module.exports = __webpack_public_path__ + "media/buy-now/bag1-26c74dc8.png";